import { useQuery } from "@tanstack/react-query";

import { DEAL_CAPTURE_STUB } from "@/lib/deal-capture/stub-data";
import type { DealCaptureLookups, DealCaptureOverview } from "@/types/deal-capture";

/**
 * Deal Capture's data, behind two hooks.
 *
 * **Stubbed until AB#8980's API exists.** Both `queryFn`s resolve
 * `DEAL_CAPTURE_STUB`; nothing else reads the stub. When the endpoints land,
 * each `queryFn` becomes an `api.get` and the stub file is deleted. Every
 * caller already handles loading, so the swap changes nothing else.
 */
export function useDealCaptureOverview() {
  return useQuery<DealCaptureOverview>({
    queryKey: ["deal-capture", "overview"],
    queryFn: () => Promise.resolve(DEAL_CAPTURE_STUB.overview),
    staleTime: Infinity,
  });
}

/** The deals, contracts and entities the sidebar pickers search. */
export function useDealCaptureLookups() {
  return useQuery<DealCaptureLookups>({
    queryKey: ["deal-capture", "lookups"],
    queryFn: () => Promise.resolve(DEAL_CAPTURE_STUB.lookups),
    staleTime: Infinity,
  });
}
